import { useServerInfo } from '@go-client/context/ServerInfoContext';
import { evaluateMergedVars } from '@go-shared/lib/mergedVars';
import { truncate } from '@go-shared/lib/string';
import { MergedVariables } from '@go-shared/types/mergedVars';
import React, { useEffect, useState } from 'react';

export interface BubbleMergedVarHintChildProps {}

export interface BubbleMergedVarHintPropsBase {
  text: string;
  mergedVars?: MergedVariables;
  textOnly?: boolean;
}

export type BubbleMergedVarHintProps = {} & BubbleMergedVarHintPropsBase;

export default function BubbleMergedVarHint(props: BubbleMergedVarHintProps) {
  const [showValue, setShowValue] = useState(true);
  const [timer, setTimer] = useState<ReturnType<typeof setTimeout> | null>(null);
  const { defaultLanguage } = useServerInfo();

  const [text] = evaluateMergedVars(
    props.text,
    undefined,
    [],
    defaultLanguage.key,
    defaultLanguage.key,
    props.mergedVars,
    (text, key, isMissing) => {
      if (props.textOnly) {
        return `<span>${text}</span>`;
      }

      const truncatedKey = truncate(key || '', 15 + 3);

      if (isMissing) {
        return `<span class="font-bold underline text-crimson">${`$${truncatedKey}$`}</span>`;
      }

      return `<span class="font-bold underline text-lime-darker">${
        showValue ? text : `$${truncatedKey}$`
      }</span>`;
    }
  );

  useEffect(() => {
    if (timer) {
      clearTimeout(timer);
    }

    const ts = setTimeout(() => {
      setShowValue(true);
    }, 5 * 1000);

    setTimer(ts);

    return () => clearTimeout(ts);
  }, [showValue]);

  return (
    <div
      onClick={() => (!props.textOnly ? setShowValue(!showValue) : undefined)}
      dangerouslySetInnerHTML={{ __html: text }}
      className="cursor-pointer"
    ></div>
  );
}
